var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { "margin-right": "30px" } },
    [
      _vm.instanceId
        ? _c(
            "a-button",
            { attrs: { type: "primary" }, on: { click: _vm.showHisPanel } },
            [_vm._v("查看审批记录 ")]
          )
        : _vm._e(),
      _c(
        "a-modal",
        {
          attrs: {
            title: "查看审批记录",
            centered: "",
            visible: _vm.showHistory,
            footer: null,
            width: 800,
          },
          on: {
            cancel: function ($event) {
              _vm.showHistory = false
            },
          },
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                width: "700px",
                height: "200px",
                background: "#fff",
                margin: "0 auto",
              },
            },
            [
              _c("img", {
                staticStyle: {
                  width: "100%",
                  height: "100%",
                  "object-fit": "contain",
                },
                attrs: { src: _vm.recordImg, alt: "" },
              }),
            ]
          ),
          _c(
            "vxe-grid",
            _vm._b(
              {
                ref: "xGrid",
                staticClass: "column-sortable-grid",
                attrs: {
                  "column-key": "",
                  data: _vm.list,
                  "auto-resize": true,
                },
              },
              "vxe-grid",
              _vm.gridOptions,
              false
            )
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }